import { Colaborador } from '@/store/catalogos/colaborador';
import { Util } from '@/utils/util';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { ApiService } from '@services/api.service';
import { AppService } from '@services/app.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
    sesion: Colaborador;
    fechaHoy: string;
    constructor(
        private renderer: Renderer2,
        private toastr: ToastrService,
        private apiService: ApiService,
        private util: Util
    ) { }


    ngOnInit() {
        this.sesion = this.util.getSesion();
        const hoy = new Date();
        this.fechaHoy = hoy.toLocaleDateString('es-MX', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    }
    /*
    try {
        this.apiService.menu().subscribe(response=>{
            
        }, error=>{
            this.toastr.error("Credenciales invalidas");
        });
    } catch (error) {
        this.toastr.error("Credenciales invalidas");
    }*/
}


